module.exports = __webpack_public_path__ + "media/images/icon-progress-dot-f1068f68962f9a61c90bf268723fc299.svg";